import { create } from "zustand";
import { HireHistoryItem } from "../../models/hireHistory/hireHistoryRes";

interface HistoryState {
  selectedHistoryState: HireHistoryItem | undefined;
  setSelectedHistoryState: (value: HireHistoryItem) => void;
}

export const useHistoryState = create<HistoryState>((set) => ({
  selectedHistoryState: undefined,
  setSelectedHistoryState: (value) =>
    set(() => ({ selectedHistoryState: value })),
}));
